export default __webpack_public_path__ + "static/hero-about-f715fb3921720c895d8075ff3f572689.jpg";